import { useEffect, useState, useRef } from "react";
import { EventScheme, ProductScheme } from "client-v2";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";

import WizardContainer, {
	WizardContainerRef,
} from "../../components/container/WizardContainer";
import Ticket from "../../components/section/Ticket";
import Success from "./section/Success";
import PaymentMethod from "../../components/section/donation/PaymentMethod";
import SuccessRight from "../../components/section/success/SuccessCrossSell";

const Checkout = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile,
	);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const wizard = useRef<WizardContainerRef>(null);

	const view = "event";

	const [event, setEvent] = useState<EventScheme | undefined>(undefined);
	const [product, setProduct] = useState<ProductScheme | undefined>(
		undefined,
	);
	const [imageAuth, setImageAuth] = useState(false);

	useEffect(() => {
		//init
		if (location.state && location.state.event && location.state.product) {
			setEvent(location.state.event);
			setProduct(location.state.product);
		} else {
			navigate("/");
		}
	}, []);

	return (
		<WizardContainer
			ref={wizard}
			views={[
				//Ticket resume
				{
					centralView: currentUser && product && (
						<Ticket
							product={product}
							user={currentUser}
							onFinish={(result) => {
								if (result.error) {
									setShowError({
										show: true,
										message: result.error,
									});
								} else if (result.data) {
									setImageAuth(result.data.imageCheck);
									wizard.current?.goNext(result.data.step);
								}
							}}
						/>
					),
				},
				//Select payment method
				{
					centralView:
						product && currentUser ? (
							<PaymentMethod
								product={product}
								imageAuth={imageAuth}
								user={currentUser}
								view={view}
								onFinish={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										wizard.current?.goNext();
									}
								}}
							/>
						) : null,
					rightView: null,
				},
				//Success view
				{
					centralView: currentUser ? (
						<>
							<Success event={event} product={product} />
						</>
					) : null,
					rightView: !isMobile ? <SuccessRight /> : null,
					hideBackButton: true,
				},
			]}
		/>
	);
};
export default Checkout;
export interface Props {}
